import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const WELCOME_CONTENT = {
  developer: {
    greeting: 'Welcome to the Lab',
    subtitle: 'Loading workspace, models, pipelines, and everything in between.',
  },
  recruiter: {
    greeting: 'Good to Have You Here',
    subtitle: 'Preparing a curated look at my impact, credentials, and what I bring to the table.',
  },
  athlete: {
    greeting: 'Discipline Over Motivation',
    subtitle: 'Loading the grind: stats, sessions, and the work behind the work.',
  },
};

const DURATION = 3000; // ms

const WelcomeScreen = ({ persona, onComplete }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
    }, DURATION);
    return () => clearTimeout(timer);
  }, []);

  const content = WELCOME_CONTENT[persona] || WELCOME_CONTENT.developer;

  return (
    <AnimatePresence onExitComplete={onComplete}>
      {visible && (
        <motion.div
          key="welcome"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6, ease: 'easeInOut' }}
          className="fixed inset-0 z-[70] bg-pure-black flex flex-col items-center justify-center px-6"
        >
          {/* Greeting */}
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.7, ease: 'easeOut' }}
            className="text-4xl md:text-6xl font-bold text-pure-white text-center tracking-tight mb-4"
          >
            {content.greeting}
          </motion.h1>

          {/* Subtitle */}
          <motion.p
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.7, duration: 0.6, ease: 'easeOut' }}
            className="text-base md:text-lg text-gray-500 text-center max-w-lg leading-relaxed mb-16"
          >
            {content.subtitle}
          </motion.p>

          {/* Progress Bar */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5, duration: 0.4 }}
            className="w-48 md:w-56"
          >
            <div className="h-[3px] w-full bg-white/10 rounded-full overflow-hidden">
              <motion.div
                initial={{ width: '0%' }}
                animate={{ width: '100%' }}
                transition={{
                  duration: DURATION / 1000 - 0.5,
                  delay: 0.5,
                  ease: [0.25, 0.1, 0.25, 1],
                }}
                className="h-full rounded-full"
                style={{
                  background: 'linear-gradient(90deg, #007AFF, #5AC8FA)',
                }}
              />
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default WelcomeScreen;
